<template>
	<type-wrapper class="type-P" limit :bgUrl="showData.image">
		<type-grid row="1" margin>
			<type-title large weight="normal" v-if="showData.title">{{ showData.title }}</type-title>
			<type-content large center v-if="showData.content">{{ showData.content }}</type-content>
		</type-grid>
		<type-grid row="1" margin center>
			<type-button round :whitebackdrop="whitebackdrop" @click="downloadFile(showData.url || '')" :style="buttonStyle[whitebackdrop ? 0 : 1]">Download</type-button>
		</type-grid>
	</type-wrapper>
</template>

<script>
	// 下载文件
	import mixin from '../mixin.js'
	export default {
		name: 'type-P',
		mixins: [ mixin ],
		methods: {
			downloadFile(url = '') {
				/**
				 * 跨域会直接打开
				 * 如果是zip包则没有问题
				 * */
				if (url) {
					const a = document.createElement('a');
					const fileName = url.slice(url.lastIndexOf('/') + 1, url.length);
					a.download = fileName;
					a.href = url;
					document.body.appendChild(a);
					a.click();
					document.body.removeChild(a);
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.type-P{}
</style>
